import { Component } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { inject, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InspectorsService } from 'src/app/core/services/inspectors/inspectors.service';
import type { CohortExpertData } from 'src/app/features/ask-ayen/models/cohort-expert.model';

@Component({
  selector: 'app-add-cohort-expert',
  standalone: false,
  templateUrl: './add-cohort-expert.component.html',
  styleUrls: ['./add-cohort-expert.component.scss'],
})
export class AddCohortExpertComponent implements OnInit {

  data: CohortExpertData = inject(MAT_DIALOG_DATA) as CohortExpertData;
  private inspectorsService = inject(InspectorsService);
  private destroyRef = inject(DestroyRef);
  page: number = 1;
  page_count: number = 1;
  experts: any[] = [];
  expertSearchInput: string = '';
  expertSearchTimeout: ReturnType<typeof setTimeout> | undefined;

  ngOnInit(): void {
    if (this.data.isEditMode) {
      this.getExpertByID(this.data.initExperts[0]);
    } else {
      this.getExperts();
    }
    this.setExperts(this.data.initExperts);
  }

  getExpertByID(expertId: number) {
    this.inspectorsService.getInspectorByID(expertId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
      this.experts = [response];
    });
  }

  getExperts() {
    let params: { [key: string]: any } = {
      page: this.page,
      page_size: 10
    };
    if (this.expertSearchInput && this.expertSearchInput.length > 0) {
      params['full_name'] = this.expertSearchInput;
    }
    this.inspectorsService.getAvailableInspectors(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {

      const newExperts = response.results.filter(
        (newItem: any) => !this.experts.some(existing => existing.id === newItem.id)
      );
      this.experts = [...this.experts, ...newExperts];
      this.page_count = response.pages_count || 1;
    });
  }

  setExperts(expertIds: number[]) {
    this.data.initExperts = expertIds;
    this.data.expert_ids = expertIds;
  }

  updateExperts(event: any) {
    if (event.reset) {
      this.page = 1;
      this.expertSearchInput = '';
    } else {
      this.page = event.page ? event.page : this.page;
      this.expertSearchInput = event?.searchInput;
    }
    this.getExperts();

  }

  onScrollExpertOptions() {
    if (this.page < this.page_count) {
      this.page++;
      this.getExperts();
    }
  }

  onSpecializationChange(event: any, specializationId: number) {
    if (event.target.checked) {
      this.data.specialization_ids.push(specializationId);
    } else {
      this.data.specialization_ids = this.data.specialization_ids.filter(id => id !== specializationId);
    }
  }
}
